__turbopack_context__.v({
  "banner": "sEK6ZG_banner",
  "body": "sEK6ZG_body",
  "bodyList": "sEK6ZG_bodyList",
  "breadcrumb": "sEK6ZG_breadcrumb",
  "breadcrumb-link": "sEK6ZG_breadcrumb-link",
  "breadcrumb-wrap": "sEK6ZG_breadcrumb-wrap",
  "button-join": "sEK6ZG_button-join",
  "card-benefit": "sEK6ZG_card-benefit",
  "career-benefits": "sEK6ZG_career-benefits",
  "career-content": "sEK6ZG_career-content",
  "career-wrap": "sEK6ZG_career-wrap",
  "content-head": "sEK6ZG_content-head",
  "content-main-title": "sEK6ZG_content-main-title",
  "content-title": "sEK6ZG_content-title",
  "desc": "sEK6ZG_desc",
  "guide-desc": "sEK6ZG_guide-desc",
  "guide-group": "sEK6ZG_guide-group",
  "guide-main": "sEK6ZG_guide-main",
  "head": "sEK6ZG_head",
  "icon-arrow": "sEK6ZG_icon-arrow",
  "job-link-btn": "sEK6ZG_job-link-btn",
  "job-team": "sEK6ZG_job-team",
  "job-title": "sEK6ZG_job-title",
  "job-type": "sEK6ZG_job-type",
  "link-button": "sEK6ZG_link-button",
  "load-more-button": "sEK6ZG_load-more-button",
  "loader": "sEK6ZG_loader",
  "page-title": "sEK6ZG_page-title",
  "position-card": "sEK6ZG_position-card",
  "position-list": "sEK6ZG_position-list",
  "positions-wrap": "sEK6ZG_positions-wrap",
  "static-label": "sEK6ZG_static-label",
  "team-label": "sEK6ZG_team-label",
  "text-intro": "sEK6ZG_text-intro",
});
